<mat-card>
  <mat-card-content>
    <form
      class="flex flex-col p-4"
      [formGroup]="form"
      (ngSubmit)="sendLoginLink()"
    >
      <h2 class="pb-4">Verify Your Email to View Referral</h2>
      @if (expectedEmail(); as expected) {
        <p class="w-80 pb-4 text-sm" data-testid="expected-email-hint">
          This referral was sent to <strong>{{ expected }}</strong
          >. Sign in with that email address to open it.
        </p>
      }
      <mat-form-field class="w-80">
        <mat-label>Email</mat-label>
        <input
          matInput
          formControlName="email"
          data-testid="email-input"
          type="email"
          placeholder="Enter your email"
          required
        />
        <mat-error *ngIf="form.controls.email.hasError('required')">
          Email is required.
        </mat-error>
        <mat-error *ngIf="form.controls.email.hasError('email')">
          Please enter a valid email address.
        </mat-error>
      </mat-form-field>

      @if (isUnexpectedEmail()) {
        <div
          class="mb-4 flex w-80 gap-2 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm"
          data-testid="unexpected-email-warning"
        >
          <mat-icon class="shrink-0 text-amber-600">warning</mat-icon>
          <p>
            This isn't the address the referral was sent to. You won't be able
            to open the referral unless you sign in with
            <strong>{{ expectedEmail() }}</strong
            >.
          </p>
        </div>
      }

      <pt-buttons-container>
        <button
          mat-flat-button
          class="flex-1"
          color="primary"
          type="submit"
          [disabled]="form.invalid"
        >
          Send Verification Link
        </button>
      </pt-buttons-container>
    </form>

    @if (linkSent()) {
      <div
        class="mx-4 mb-4 flex gap-3 rounded-lg border border-blue-200 bg-blue-50 p-4 text-sm"
        data-testid="link-sent-info"
      >
        <mat-icon class="text-blue-600">info</mat-icon>
        <div>
          <p class="font-semibold">Check your email</p>
          <p>
            We've sent a verification email to
            <strong>{{ submittedEmail() }}</strong
            >. To view the referral:
          </p>
          <ol class="ml-4 mt-2 list-decimal">
            <li>
              Open the email from <strong>Principle</strong> (check your spam
              folder if you don't see it)
            </li>
            <li>
              Click the <strong>"Sign in to Principle"</strong> link in that
              email
            </li>
            <li>You'll be redirected back here to view the referral</li>
          </ol>
          <p class="mt-2 text-xs italic">
            The email may take a minute to arrive.
          </p>
        </div>
      </div>
    }

    @if (linkSendError()) {
      <div
        class="mx-4 mb-4 flex gap-3 rounded-lg border border-red-200 bg-red-50 p-4 text-sm"
        data-testid="link-send-error"
      >
        <mat-icon class="text-red-600">warning</mat-icon>
        <p>
          There was a problem sending the verification email. Please try again.
        </p>
      </div>
    }
  </mat-card-content>
</mat-card>
